export default __webpack_public_path__ + "static/media/toppage.66eb63e0.png";